import produce from 'immer';
import { useReducer } from 'react';

// eslint-disable-next-line default-param-last
function useSetReducer(initial = [], options) {
  const reducer = produce((draft, action) => {
    const { type, value } = action;
    switch (type) {
      case 'add':
        draft.add(value);
        break;
      case 'delete':
        draft.delete(value);
        break;
      case 'addAll':
        options.forEach((id) => draft.add(id));
        break;
      case 'clear':
      case 'deleteAll':
        draft.clear();
        break;
      default:
        throw new Error('Invalid action type');
    }
  });
  return useReducer(reducer, new Set(initial));
}

export default useSetReducer;
